/**
 * AppFooter - Footer wrapper for BottomNavigation
 * Glassmorphic design, always visible at bottom
 */

import React from 'react';
import BottomNavigation from '../BottomNavigation';
import './AppFooter.css';

interface AppFooterProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  onMyVibeClick?: () => void;
}

const AppFooter: React.FC<AppFooterProps> = ({
  activeTab,
  onTabChange,
  onMyVibeClick
}) => {
  return (
    <footer className="app-footer">
      <BottomNavigation
        activeTab={activeTab}
        onTabChange={onTabChange}
        onMyVibeClick={onMyVibeClick}
      />
    </footer>
  );
};

export default AppFooter;
